export const getInventoryLocationsByStore = data => {
  return Object.fromEntries((data || []).map(entry => [entry.store_id, entry.locations]))
}
